import {
  Activity,
  BarChart3,
  Check,
  Cpu,
  Gamepad2,
  Gauge,
  HardDrive,
  MemoryStick,
  Settings2,
  ShieldCheck,
  Sparkles
} from 'lucide-react';

const bars = [32, 46, 38, 64, 50, 76, 58, 84, 68, 91, 72, 86, 62, 77, 53, 70, 47, 65];

function MetricCard({ icon: Icon, tone, label, value, unit, detail, progress }) {
  return (
    <div className="demo-metric">
      <div className={`demo-metric-icon ${tone}`}><Icon size={14} /></div>
      <span>{label}</span>
      <strong>{value}<small>{unit}</small></strong>
      <div className="demo-progress"><i style={{ width: `${progress}%` }} /></div>
      <small>{detail}</small>
    </div>
  );
}

export default function ProductPreview() {
  return (
    <div className="product-preview" aria-label="CSS ile tasarlanmış WFast ürün arayüzü önizlemesi">
      <div className="preview-glow preview-glow-one" />
      <div className="preview-glow preview-glow-two" />

      <div className="floating-status floating-status-top">
        <span className="status-signal"><i /></span>
        <div><small>OTOMATİK ALGILANDI</small><strong>VALORANT</strong></div>
        <span className="status-check"><Check size={12} /></span>
      </div>

      <div className="demo-window">
        <div className="demo-window-top">
          <div className="demo-dots"><i /><i /><i /></div>
          <div className="demo-address"><ShieldCheck size={11} /> Sistem yerel olarak korunuyor</div>
          <div className="demo-live"><i /> CANLI</div>
        </div>

        <div className="demo-app">
          <aside className="demo-sidebar">
            <div className="demo-brand"><span><Activity size={16} /></span><b>WFast</b></div>
            <div className="demo-menu">
              <i className="active"><Gauge size={14} /></i>
              <i><Sparkles size={14} /></i>
              <i><Gamepad2 size={14} /></i>
              <i><BarChart3 size={14} /></i>
            </div>
            <i className="demo-settings"><Settings2 size={14} /></i>
          </aside>

          <main className="demo-main">
            <div className="demo-heading">
              <div><small>SİSTEM DURUMU</small><strong>Bilgisayarınız hazır</strong><span>Kaynaklar dengeli ve oyun modu beklemede.</span></div>
              <div className="demo-score"><b>94</b><small>/100</small></div>
            </div>

            <div className="demo-metrics">
              <MetricCard icon={Cpu} tone="violet" label="İşlemci" value="18" unit="%" detail="12 mantıksal çekirdek" progress={18} />
              <MetricCard icon={MemoryStick} tone="cyan" label="Bellek" value="42" unit="%" detail="13.4 GB kullanılabilir" progress={42} />
              <MetricCard icon={HardDrive} tone="green" label="Depolama" value="67" unit="%" detail="284 GB boş alan" progress={67} />
            </div>

            <div className="demo-lower">
              <div className="demo-chart-card">
                <div className="demo-card-title"><span><b>Kaynak kullanımı</b><small>Son 60 saniye</small></span><i>CANLI</i></div>
                <div className="demo-chart-grid">
                  <div className="demo-bars">{bars.map((height, index) => <i key={index} style={{ height: `${height}%` }} />)}</div>
                  <span className="demo-chart-line" />
                </div>
              </div>
              <div className="demo-focus-card">
                <div className="demo-focus-icon"><Gamepad2 size={19} /></div>
                <small>GAME FOCUS</small>
                <strong>Hazır</strong>
                <span><i /> High QoS</span>
                <span><i /> FPS katmanı</span>
              </div>
            </div>
          </main>
        </div>
      </div>

      <div className="floating-fps">
        <span className="fps-dot" />
        <strong>148</strong><b>FPS</b>
        <small>6.8 ms</small>
      </div>
      <div className="floating-clean"><Sparkles size={16} /><span><small>GÜVENLİ TEMİZLİK</small><strong>4.8 GB hazır</strong></span></div>
    </div>
  );
}
